module.exports = __webpack_public_path__ + "img/search-x.eaadfb4b.png";